import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import CallIcon from '@material-ui/icons/Call';
import Raven from 'raven-js';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import api from '../../api';
// Custom Components
import LoginBlock from '../../components/LoginBlock';
import { openPrimaryContactDialog } from '../../modules/app';
import { numberWithCommas } from '../../utils';
import styles from './styles';

class Profile extends Component {
  state = {
    mealCount: 0,
    organisations: [],
    primaryContactDialogOpen: false,
    userFilter: '',
    impact: []
  };

  componentDidMount() {
    const { user, loggedIn } = this.props;
    if (loggedIn) {
      this._getMyImpact();
      this._getMyOrganisations();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { user, loggedIn } = this.props;
    if (!prevProps.loggedIn && loggedIn) {
      this._getMyImpact();
      this._getMyOrganisations();
    }
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  _getMyOrganisations = () => {
    api
      .getMyOrganisations()
      .then(data => {
        this.setState({ organisations: data.results });
      })
      .catch(err => {
        console.log(err);
      });
  };

  _getMyImpact = () => {
    api
      .getMyImpact()
      .then(result => {
        this.setState({ impact: result });
      })
      .catch(err => {
        console.log(err);
      });
  };

  _handleShowPrimaryContact = organisation => {
    this.props.openPrimaryContactDialog({
      organisation_name: organisation.organisation_name,
      primary_contact_number: organisation.primary_contact_number,
      primary_contact_name: organisation.primary_contact_name,
      primary_contact_email: organisation.primary_contact_email
    });
  };

  _handleCloseDialog = () => {
    //this.setState({ primaryContactDialogOpen: false });
  };

  _handleSearchDonations = () => {
    this.props.changePage('/profile/donations');
  };

  _handleCallOrganisation = phone_number => {
    window.open(`tel:${phone_number}`);
  };

  _renderOrganisations = () => {
    const { organisations, userFilter } = this.state;
    const { classes } = this.props;

    return organisations
      .filter(
        o =>
          !userFilter ||
          o.organisation_name.toLowerCase().includes(userFilter.toLowerCase())
      )
      .map(o => {
        const {
          organisation_name,
          address,
          phone_number,
          primary_contact_number,
          primary_contact_name
        } = o;

        const thoroughfare = address.thoroughfare;
        const locality = address.locality;
        const administrative_area = address.administrative_area;
        const postcode = address.postal_code;
        const tempAddress = `${thoroughfare}, ${locality}, ${administrative_area}, ${postcode}`;

        return (
          <Paper key={o.nid} className={classes.paper}>
            <div className={classes.organisationDetails}>
              <div className={classes.inputRow}>
                <span style={{ marginBottom: 5 }}>Name</span>
                <TextField
                  type="text"
                  value={organisation_name}
                  label=""
                  disabled
                  id="bootstrap-input"
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.textFieldRoot,
                      input: classes.textFieldInput
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.textFieldFormLabel
                  }}
                />
              </div>

              <div className={classes.inputRow}>
                <span style={{ marginBottom: 5 }}>Address</span>
                <TextField
                  type="text"
                  value={tempAddress}
                  label=""
                  disabled
                  id="bootstrap-input"
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.textFieldRoot,
                      input: classes.textFieldInput
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.textFieldFormLabel
                  }}
                />
              </div>

              <div className={classes.inputRow}>
                <span style={{ marginBottom: 5 }}>Phone Number</span>
                <TextField
                  type="text"
                  value={phone_number}
                  label=""
                  disabled
                  id="bootstrap-input"
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.textFieldRoot,
                      input: classes.textFieldInput
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.textFieldFormLabel
                  }}
                />
              </div>

              <Button
                variant="raised"
                color="primary"
                className={classes.callOrganisationButton}
                onClick={() => this._handleCallOrganisation(phone_number)}>
                <CallIcon style={{ marginRight: 10 }} />
                Call Farmer
              </Button>

              {!!primary_contact_number && !!primary_contact_name && (
                <Button
                  variant="raised"
                  color="primary"
                  className={classes.callOrganisationButton}
                  onClick={() => this._handleShowPrimaryContact(o)}>
                  Primary Contact Details
                </Button>
              )}
            </div>
          </Paper>
        );
      });
  };

  render() {
    const { loggedIn, classes, user, fullScreen } = this.props;

    if (!loggedIn) {
      return <LoginBlock />;
    }

    const {
      mealCount,
      primaryContactDialogOpen,
      userFilter,
      impact
    } = this.state;

    return (
      <Grid container className={classes.root} spacing={0}>
        <Grid item xs={12}>
          <h1 className={classes.title}>My Total Impact</h1>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Paper className={classes.paper}>
            <div className={classes.impactCircle}>
              <img
                className={classes.logoImage}
                src={require('../../images/logo.png')}
              />
              <span className={classes.mealCountText}>
                {numberWithCommas(impact[3])} Meals
              </span>
              <span className={classes.countingText}>& Counting</span>
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <h1 className={classes.title}>My Donations</h1>
        </Grid>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Button
              variant="raised"
              color="primary"
              className={classes.searchDonationsButton}
              onClick={this._handleSearchDonations}>
              View Donations
            </Button>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <h1 className={classes.title}>My Food Relief Farmers</h1>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: 24
            }}>
            <div
              style={{
                maxWidth: 400
              }}>
              <TextField
                label=""
                id="bootstrap-input"
                value={userFilter}
                placeholder="Farmer search"
                onChange={e => this.setState({ userFilter: e.target.value })}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.textFieldRoot,
                    input: classes.textFieldInput
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.textFieldFormLabel
                }}
                style={{ backgroundColor: '#fff' }}
              />
            </div>
          </div>
        </Grid>
        <Grid className={classes.myOrganisations} item xs={12} sm={12}>
          {/*
          <ViewPager tag="main">
            <Frame className="frame">
              <Track
                ref={c => this.track = c}
                viewsToShow={1}
                className="track"
              >


              </Track>
            </Frame>
          </ViewPager>
          */}

          {this._renderOrganisations()}
        </Grid>
      </Grid>
    );
  }
}

Profile = withStyles(styles)(Profile);

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn,
  user: state.user.data
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: url => push(url),
      openPrimaryContactDialog: data => openPrimaryContactDialog(data)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/containers/profile/index.js